import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IStateType } from '../store/models/root.interface';
import {Helmet} from "react-helmet";

declare global {
    interface Window {
        chmln: any;
    }
}

const ChamelonPackage = () => {

    const profile = useSelector((state: IStateType) => state.profile);

    useEffect(()=>{
        if(profile){
            setTimeout(() => {
                const chmln = window.chmln; 
                chmln.identify(profile?.fullProfile?.user_id, {    
                    email: profile?.fullProfile?.email,
                    created: profile?.fullProfile?.user_signup,
                    name: profile?.name,         
                    company: {                        
                        uid: profile?.fullProfile?.company_id,
                        created: profile?.fullProfile?.company_signup,
                        name: profile?.companyName,
                    }
                });
            }, 5000);
        }
    },[]);

    return(
        <Helmet>
            <script type="text/javascript" src={'https://whatsapp-media-mnt-sg.s3-ap-southeast-1.amazonaws.com/js/chameleon.js'}/>
        </Helmet> 
    ) 
};

export default ChamelonPackage;